import { render, staticRenderFns } from "./PurchOrdersearch.vue?vue&type=template&id=628845a7&"
import script from "./PurchOrdersearch.vue?vue&type=script&lang=js&"
export * from "./PurchOrdersearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports